import { isServerSide } from "@jti/fe-common";

export class BrowserStorage {
  constructor(private _storage: Storage | undefined = !isServerSide() ? window.localStorage : undefined) {}

  get<V>(key: string, defaultValue: V): V {
    const value = this._storage?.getItem(key);
    if (!value) {
      return defaultValue;
    }
    return JSON.parse(value) as V;
  }

  set<V>(key: string, value: V): void {
    this._storage?.setItem(key, JSON.stringify(value));
  }

  delete(key: string): void {
    this._storage?.removeItem(key);
  }
}

export default BrowserStorage;

export const getSessionStorage = () => new BrowserStorage(!isServerSide() ? window.sessionStorage : undefined);

export const getLocalStorage = () => new BrowserStorage(!isServerSide() ? window.localStorage : undefined);
